// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineHome } from "react-icons/ai";
import { MdOutlineScoreboard } from "react-icons/md";
import { BsClockHistory } from "react-icons/bs";
import { IoSettingsOutline } from "react-icons/io5";

const Footer = () => (
  <footer className="w-full text-white shadow-md z-50 h-16">
    <div className="hidden flex items-center justify-around w-full">
      {/* Home Button */}
      <Link to="/">
        <button className="flex flex-col items-center text-orange-500 focus:outline-none">
          <AiOutlineHome className="w-5 h-5 mb-1" />
          <span className="text-[10px]">Home</span>
        </button>
      </Link>

      {/* Score Button */}
      <Link to="/statistics">
        <button className="flex flex-col items-center text-orange-500 focus:outline-none">
          <MdOutlineScoreboard className="w-5 h-5 mb-1" />
          <span className="text-[10px]">Scoring</span>
        </button>
      </Link>

      {/* History Button */}
      <Link to="/history">
        <button className="flex flex-col items-center text-orange-500 focus:outline-none">
          <BsClockHistory className="w-5 h-5 mb-1" />
          <span className="text-[10px]">History</span>
        </button>
      </Link>

      {/* Settings Button */}
      <Link to="/settings">
        <button className="flex flex-col items-center text-orange-500 focus:outline-none">
          <IoSettingsOutline className="w-5 h-5 mb-1" />
          <span className="text-[10px]">Settings</span>
        </button>
      </Link>
    </div>

    <div className="h-full flex items-center justify-center">
      <p className="text-[9px] md:text-xs text-lightGray">
        <Link to="/legal-notice" className="text-lightGray hover:text-test">
          Legal Notice
        </Link>
        {" | "}
        <Link to="/privacy-policy" className="text-lightGray hover:text-test">
          Privacy Policy
        </Link>
        {" | "}&copy; 2025 99Corporation
      </p>
    </div>
  </footer>
);

export default Footer;
